import "./App.scss";

import { Provider } from "react-redux";
import { store } from "./store";
import React from "react";
import { Pages } from "./pages";

function App() {
  return (
    <React.Suspense>
      <Provider store={store}>
        <Pages />
      </Provider>
  </React.Suspense>
  );
}

export default App;
